import { ROUTE_PATHS } from 'utils/constant'
import { AnimatePresence, Variants, motion } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import { getGTM, sleep, throttle } from 'utils/functions'
import { SPMenu } from '../menu'

export function SPHeader() {
  const [open, setOpen] = useState(false)

  const block = useRef<boolean>(false)

  const logoRef = useRef<HTMLAnchorElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  const toggle = async () => {
    if (!block.current) {
      block.current = true
      const newOpen = !open
      document.documentElement.classList.toggle('block', newOpen)
      setOpen(newOpen)
      await sleep(500)
      block.current = false
    }
  }

  const svgVariants: Variants = {
    close: { width: 15, height: 27, viewBox: '0 0 15 27' },
    open: { width: 15, height: 8, viewBox: '0 0 15 8' },
  }

  const path01Variants: Variants = {
    close: {
      d: 'M13.5 3.5L1.5 1',
      transition: { duration: 0.5, type: 'spring' },
    },
    open: { d: 'M14 6.5L1 1', transition: { duration: 0.5, type: 'spring' } },
  }

  const path02Variants: Variants = {
    close: {
      d: 'M1.5 25.5L13.5 23',
      transition: { duration: 0.5, type: 'spring' },
    },
    open: {
      d: 'M1 6.5L14 1',
      transition: { duration: 0.5, type: 'spring' },
    },
  }

  useEffect(() => {
    const footer = document.getElementById('spfooter')
    const spFv = document.getElementById('spfv')

    const onScroll = () => {
      const { scrollY } = window

      const bpFv = Number(spFv?.clientHeight)
      const bpFooter = Number(footer?.offsetTop)

      const isHeaderBlur = String(scrollY > bpFv)

      containerRef.current?.setAttribute('data-header-blur', isHeaderBlur)

      const logoState = scrollY <= bpFv ? '1' : scrollY <= bpFooter ? '2' : '1'

      logoRef.current?.setAttribute('data-logo-state', logoState)
    }

    const throttleScroll = throttle(onScroll, 100)

    onScroll()
    window.addEventListener('scroll', throttleScroll)
    return () => {
      window.removeEventListener('scroll', throttleScroll)
    }
  }, [])

  return (
    <header
      ref={containerRef}
      data-header-blur='false'
      className='fixed h-[57px] left-0 top-0 w-screen px-4 flex items-center justify-between z-[1001]'
    >
      <SPMenu open={open} onClick={toggle} />
      <a
        ref={logoRef}
        href={ROUTE_PATHS.TOP}
        aria-label='logo'
        {...getGTM({
          event_name: 'button_click',
          content_type: 'header',
          content_id: 'comado_ロゴ',
        })}
        data-logo-state='1'
        className='h-6 w-24 bg-no-repeat bg-contain'
      />
      <button
        type='button'
        className='outline-none border-none relative flex items-center justify-end z-[10001]'
        aria-label='menu-btn'
        onClick={toggle}
      >
        <motion.svg
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          variants={svgVariants}
          initial='close'
          animate={open ? 'open' : 'close'}
          className='absolute'
        >
          <motion.path
            variants={path01Variants}
            initial='close'
            animate={open ? 'open' : 'close'}
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
          />
          <motion.path
            variants={path02Variants}
            initial='close'
            animate={open ? 'open' : 'close'}
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
          />
        </motion.svg>
        <AnimatePresence>
          {open ? (
            <motion.img
              initial={{ opacity: 0, x: 0 }}
              animate={{ opacity: 1, x: -20 }}
              exit={{ opacity: 0, x: 0 }}
              transition={{ duration: 0.3, type: 'spring' }}
              src='/images/top-sp/header/menu-close.png'
              alt='menu-close'
              className='w-[44px] object-contain'
            />
          ) : (
            <motion.img
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.5, type: 'spring' }}
              src='/images/top-sp/header/menu-open.png'
              alt='menu-open'
              className='w-[44px] object-contain'
            />
          )}
        </AnimatePresence>
      </button>
    </header>
  )
}
